var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPresentation = function SvgPresentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232322",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m8.498 12.412-1.043 3.91m3.65-3.91.913 3.91m-10.685 0h13.82m-12.256 0 2.086 14.342m-3.65.003h16.688m-1.824-8.2-1.043 8.196m-.92-18.248H5.108c-1.043 0-1.955-.913-1.955-1.956V5.244c0-1.043.912-1.955 1.955-1.955h9.126c1.043 0 1.956.912 1.956 1.955v5.215c.13 1.043-.783 1.956-1.956 1.956M24.8 9.155a3.911 3.911 0 1 0 0-7.822 3.911 3.911 0 0 0 0 7.822m2.868 21.512 1.043-9.778c1.043 0 1.956-.913 1.956-1.956v-1.955A5.84 5.84 0 0 0 24.8 11.11a5.84 5.84 0 0 0-5.867 5.867v1.955c0 1.043.913 1.956 1.956 1.956l1.043 9.778zm-17.47-4.563c1.08 0 1.956-1.168 1.956-2.608s-.876-2.607-1.956-2.607-1.955 1.167-1.955 2.607.875 2.608 1.955 2.608",
    vectorEffect: "non-scaling-stroke"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgPresentation;